const pageNameKey = "saveBlueprintModal";

export const saveBlueprintModalEn = {
  [pageNameKey]: {
    successMessage: "Blueprint has been successfully saved.",
    errorMessage: "Failed to save blueprint",
    errorNodeStructureForBlueprintTooManyNodes:
      "Unable to save Blueprint: nodeset size exceeds maximum number of nodes (50000).",
    subTitle: "Save Structure as Blueprint",
    inputLabel: "Blueprint",
    inputPlaceHolder: "Enter Blueprint Name",
    textAreaLabel: "Description (optional)",
    textAreaPlaceholder: "Describe the specifics of this blueprint...",
    saveButton: "Save Blueprint",
    cancelButton: "Cancel",
  },
};

export const saveBlueprintModalPtBr = {
  [pageNameKey]: {
    successMessage: "O blueprint foi salvo com sucesso.",
    errorMessage: "Falha ao salvar o blueprint",
    errorNodeStructureForBlueprintTooManyNodes:
      "Não foi possível salvar o Blueprint: o tamanho do conjunto de nós excede o número máximo de nós (50000).",
    subTitle: "Salvar estrutura como planta",
    inputLabel: "Projeto",
    inputPlaceHolder: "Insira o nome do blueprint",
    textAreaLabel: "Descrição (opcional)",
    textAreaPlaceholder: "Descreva os detalhes desta planta...",
    saveButton: "Salvar modelo",
    cancelButton: "Cancelar",
  },
};

export const saveBlueprintModalDe = {
  [pageNameKey]: {
    successMessage: "Blueprint wurde erfolgreich gespeichert.",
    errorMessage: "Fehler beim Speichern des Blueprints",
    errorNodeStructureForBlueprintTooManyNodes:
      "Blueprint kann nicht gespeichert werden: Knotenanzahl überschreitet die maximale Anzahl von Knoten (50000).",
    subTitle: "Struktur als Blueprint speichern",
    inputLabel: "Blueprint",
    inputPlaceHolder: "Blueprint-Namen eingeben",
    textAreaLabel: "Beschreibung (optional)",
    textAreaPlaceholder:
      "Beschreiben Sie die Einzelheiten dieses Blueprints...",
    saveButton: "Blueprint speichern",
    cancelButton: "Abbrechen",
  },
};

export const saveBlueprintModalZhHans = {
  [pageNameKey]: {
    successMessage: "Blueprint 已成功保存。",
    errorMessage: "保存 Blueprint 失败",
    errorNodeStructureForBlueprintTooManyNodes:
      "无法保存 Blueprint：节点集大小超过最大节点数（50000）。",
    subTitle: "将结构保存为 Blueprint",
    inputLabel: "Blueprint",
    inputPlaceHolder: "输入 Blueprint 名称",
    textAreaLabel: "描述（可选）",
    textAreaPlaceholder: "描述此 Blueprint 的具体内容...",
    saveButton: "保存 Blueprint",
    cancelButton: "取消",
  },
};

export const saveBlueprintModalIt = {
  [pageNameKey]: {
    successMessage: "Blueprint è stato salvato con successo.",
    errorMessage: "Impossibile salvare il Blueprint",
    errorNodeStructureForBlueprintTooManyNodes:
      "Impossibile salvare il Blueprint: la dimensione del nodeset supera il massimo numero di nodi (50000).",
    subTitle: "Salva Struttura come Blueprint",
    inputLabel: "Blueprint",
    inputPlaceHolder: "Inserisci il nome del Blueprint",
    textAreaLabel: "Descrizione (opzionale)",
    textAreaPlaceholder: "Descrivi i dettagli di questo Blueprint...",
    saveButton: "Salva Blueprint",
    cancelButton: "Annulla",
  },
};

export const saveBlueprintModalEs = {
  [pageNameKey]: {
    successMessage: "El plano se ha guardado correctamente.",
    errorMessage: "Error al guardar el plano",
    errorNodeStructureForBlueprintTooManyNodes:
      "No se puede guardar el plano: el tamaño del conjunto de nodos supera el número máximo de nodos (50000).",
    subTitle: "Guardar estructura como plano",
    inputLabel: "Plano",
    inputPlaceHolder: "Introduce el nombre del plano",
    textAreaLabel: "Descripción (opcional)",
    textAreaPlaceholder: "Describe los detalles específicos de este plano...",
    saveButton: "Guardar plano",
    cancelButton: "Cancelar",
  },
};

export const saveBlueprintModalNl = {
  [pageNameKey]: {
    cancelButton: "Annuleren",
    errorMessage: "Fout bij het opslaan van de blueprint",
    errorNodeStructureForBlueprintTooManyNodes:
      "Kan blueprint niet opslaan: nodeset-grootte overschrijdt het maximale aantal nodes (50000).",
    inputLabel: "Blueprint",
    inputPlaceHolder: "Blueprintnaam invoeren",
    saveButton: "Blueprint opslaan",
    subTitle: "Structuur opslaan als blueprint",
    successMessage: "Blueprint is succesvol opgeslagen.",
    textAreaLabel: "Beschrijving (optioneel)",
    textAreaPlaceholder: "Beschrijf de details van deze blueprint...",
  },
};

export const saveBlueprintModalTr = {
  [pageNameKey]: {
    cancelButton: "İptal etmek",
    errorMessage: "Plan kaydedilemedi",
    errorNodeStructureForBlueprintTooManyNodes:
      "Blueprint kaydedilemiyor: düğüm kümesi boyutu maksimum düğüm sayısını (50000) aşıyor.",
    inputLabel: "Taslak",
    inputPlaceHolder: "Plan Adını Girin",
    saveButton: "Planı Kaydet",
    subTitle: "Yapıyı Plan Olarak Kaydet",
    successMessage: "Plan başarıyla kaydedildi.",
    textAreaLabel: "Açıklama (isteğe bağlı)",
    textAreaPlaceholder: "Bu planın özelliklerini açıklayın...",
  },
};
